export default __webpack_public_path__ + "static/media/vault-protection-logo.aa30c113.svg";